var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_468_70115)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0ZM9.55509 6.82506C9.21218 6.39688 8.53891 6.80457 8.75943 7.30686L9.87683 9.85205C10.0204 10.179 9.76058 10.54 9.405 10.5078L6.59612 10.2534C6.04581 10.2035 5.87709 10.9802 6.39848 11.1632L8.90375 12.0423C9.25401 12.1653 9.32951 12.627 9.03662 12.8551L6.91387 14.508C6.47504 14.8497 6.89033 15.5355 7.39649 15.305L9.84492 14.1899C10.1827 14.0361 10.557 14.317 10.5036 14.6843L10.1216 17.3118C10.0422 17.8586 10.8086 18.069 11.0194 17.5582L12.0957 14.9513C12.2319 14.6213 12.6722 14.5584 12.8954 14.837L14.633 17.0067C14.9759 17.4349 15.6492 17.0272 15.4287 16.5249L14.3112 13.9797C14.1677 13.6528 14.4275 13.2918 14.7831 13.324L17.592 13.5784C18.1423 13.6282 18.311 12.8515 17.7896 12.6686L15.2843 11.7894C14.9341 11.6665 14.8586 11.2047 15.1515 10.9767L17.2742 9.32375C17.713 8.98205 17.2977 8.29622 16.7916 8.52673L14.3432 9.64181C14.0053 9.79566 13.6311 9.51478 13.6845 9.14743L14.0664 6.51999C14.1459 5.97317 13.3795 5.76276 13.1686 6.27352L12.0924 8.88048C11.9562 9.2105 11.5159 9.27339 11.2927 8.99471L9.55509 6.82506Z",
    fill: "current",
    stroke: "current"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_468_70115"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "current"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon2);
export default __webpack_public_path__ + "static/media/homeIcon2.72869cd993f6fc695417e0629d5a6fc4.svg";
export { ForwardRef as ReactComponent };